// extracted by mini-css-extract-plugin
module.exports = {"pointer":"rule-editor_pointer__1UJNO"};